import classNames from "classnames";
import styles from "./Divider.module.css";
import React from "react";
function Divider({ direction = "horizontal", className, ...props }) {
    return React.createElement("div", { className: classNames(styles.divider, styles[direction], className), ...props });
}
export default Divider;
